const LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_lab-portal-45/artifacts/5i852irv_logo%203D%20print.png";
const TOOTH_3D = "https://static.prod-images.emergentagent.com/jobs/5e27b702-7d1e-4232-bc7a-913d34f904ba/images/ae619b51dbe6d61d15f25b50bcf5d863904cfb34b38f67c6392d942a0dff016c.jpeg";
const PRINTER_IMG = "https://customer-assets-jt897jd0.emergentagent.net/job_lab-portal-45/artifacts/stiftazu_rappresentazione-semplificata-in-linea-artistica-di-una-stampante-3d-cubica_9206-36128.webp";
const MOUSE_IMG = "https://customer-assets-jt897jd0.emergentagent.net/job_lab-portal-45/artifacts/gvl58kqv_1500577-mouse-icona-vettore-vettoriale.jpg";
const EXOCAD = "https://customer-assets-jt897jd0.emergentagent.net/job_lab-portal-45/artifacts/zyy9m0k6_csm_exocad-logo_RGB_d2f0394903.webp";
const B4D = "https://customer-assets-jt897jd0.emergentagent.net/job_lab-portal-45/artifacts/sq44ge3m_images.jpg";

export const SITE_IMAGES = { LOGO, TOOTH_3D, PRINTER_IMG, MOUSE_IMG, EXOCAD, B4D };

export const HERO_DEFAULTS = { width: 76, height: 82, offset_x: -2, offset_y: 0, scale: 102, pos_x: 50, pos_y: 50, fade_side: 20, fade_edge: 14, frame: false, frame_color: "#2dd4bf", frame_width: 2, frame_radius: 24 };

export function buildHeroStyles(s) {
  const c = { ...HERO_DEFAULTS, ...(s || {}) };
  const mask = `linear-gradient(to right, transparent 0%, #000 ${c.fade_side}%), linear-gradient(to bottom, transparent 0%, #000 ${c.fade_edge}%, #000 ${100 - c.fade_edge}%, transparent 100%)`;
  return {
    outer: {
      width: `${c.width}%`, height: `${c.height}%`, right: `${c.offset_x}%`, top: `calc(50% + ${c.offset_y}%)`,
      ...(c.frame ? { border: `${c.frame_width}px solid ${c.frame_color}`, borderRadius: `${c.frame_radius}px` } : {}),
    },
    mask: { WebkitMaskImage: mask, WebkitMaskComposite: "source-in", maskImage: mask, maskComposite: "intersect" },
    img: { objectPosition: `${c.pos_x}% ${c.pos_y}%`, transform: `scale(${c.scale / 100})` },
  };
}

export const SITE_DEFAULTS = {
  general: {
    logo: LOGO,
    panel_watermark_mode: "default",
    panel_watermark: "",
    phone: "+39 000 000 0000",
    email: "info@officinadentale3d.it",
    address: "Italia",
    footer_tagline: "Metodo, formazione e supporto alla stampa 3D per il settore odontotecnico. Progettazione e produzione di alta precisione.",
    nav_home: "Home",
    nav_servizi: "Servizi",
    nav_chisiamo: "Chi siamo",
    nav_contatti: "Contatti",
    area_clienti_label: "Area Clienti",
    footer_nav_title: "Naviga",
    footer_contacts_title: "Contatti",
    footer_copyright: "Officina Dentale 3D print — Tutti i diritti riservati",
  },
  home: {
    hero_kicker: "Metodo · Formazione · Supporto alla Stampa 3D",
    hero_title_pre: "Il futuro dell'odontotecnica è ",
    hero_title_highlight: "digitale",
    hero_subtitle: "Progettazione CAD e stampa 3D di alta precisione per studi dentistici e laboratori. Carica i tuoi casi, noi li trasformiamo in realtà.",
    hero_cta_primary: "Area Clienti",
    hero_cta_secondary: "Scopri i servizi",
    hero_video: "",
    hero_watermark: true,
    hero_image: TOOTH_3D,
    hero_settings: { width: 76, height: 82, offset_x: -2, offset_y: 0, scale: 102, pos_x: 50, pos_y: 50, fade_side: 20, fade_edge: 14, frame: false, frame_color: "#2dd4bf", frame_width: 2, frame_radius: 24 },
    features: [
      { title: "Qualità a 360°", desc: "Flusso interamente digitale, con continua attenzione al dettaglio in ogni fase della lavorazione." },
      { title: "Puntualità", desc: "Rispettiamo i tempi concordati e tracciamo lo stato di ogni lavoro in tempo reale." },
      { title: "Qualità certificata", desc: "Materiali biocompatibili e controlli di qualità su ogni singola lavorazione." },
    ],
    services_kicker: "I nostri servizi",
    services_title: "Due anime, un unico flusso digitale",
    stampa_title: "Stampa 3D",
    stampa_desc: "Ceramica stampata definitiva, compositi, modelli di precisione, provvisori, bite, dime chirurgiche e tanti altri prodotti.",
    stampa_image: PRINTER_IMG,
    cad_title: "Progettazione CAD",
    cad_desc: "Modellazione digitale di protesi e restauri con software professionali exocad e B4D, dalla scansione al file pronto per la produzione.",
    cad_image: MOUSE_IMG,
    cta_title: "Pronto a inviare il tuo primo caso?",
    cta_subtitle: "Accedi all'Area Clienti, carica prescrizioni e file STL e segui lo stato del lavoro in tempo reale.",
    cta_button: "Vai all'Area Clienti",
    card_link_label: "Approfondisci",
  },
  servizi: {
    hero_kicker: "Servizi",
    hero_title: "Tre modi di lavorare con noi",
    hero_subtitle: "Produzione e progettazione per studi e laboratori, formazione sulla stampa 3D e sviluppo tecnologico. Scegli l'area che ti interessa.",
    produzione_kicker: "Per studi e laboratori",
    produzione_title: "Produzione & Progettazione",
    produzione_tagline: "Fai realizzare a noi il lavoro: carica i file, li trasformiamo in dispositivi di alta precisione.",
    produzione_body: "Carica direttamente sulla piattaforma i tuoi file (STL, XML, immagini e note): pensiamo noi alla progettazione CAD e alla stampa 3D. Segui lo stato di ogni lavoro in tempo reale dalla tua Area Clienti.",
    produzione_steps: ["Accedi all'Area Clienti", "Carica prescrizione e file del caso", "Segui lo stato fino alla consegna"],
    produzione_cta: "Carica un caso · Area Clienti",
    formazione_kicker: "Per odontotecnici e laboratori",
    formazione_title: "Formazione Stampa 3D",
    formazione_tagline: "Corsi sulla stampa 3D pensati per i laboratori odontotecnici, dai fondamentali alle tecniche avanzate.",
    formazione_items: [
      "Corsi base e avanzati sulla stampa 3D",
      "Dedicati ai laboratori odontotecnici",
      "In sede presso il cliente oppure da remoto",
      "Formazione individuale o di gruppo",
      "Durata a giornata o mezza giornata",
      "Programma personalizzato sulle tue esigenze",
    ],
    formazione_cta: "Richiedi informazioni",
    sviluppo_kicker: "Innovazione e tecnologia",
    sviluppo_title: "Sviluppo",
    sviluppo_tagline: "Ricerca e sviluppo continui sulle tecnologie di stampa 3D, in partnership con i produttori.",
    sviluppo_body: "Collaboriamo con MAKEROBA, produttrice di stampanti 3D dentali e orafe: insieme abbiamo studiato e sviluppato il sistema UNO. Una partnership che ci tiene sempre all'avanguardia su stampanti, processi e materiali.",
    sviluppo_items: [
      "Sistema UNO — sviluppato insieme a MAKEROBA",
      "In arrivo: unità di post-curing",
      "In sviluppo: la nostra linea di resine dedicate",
    ],
    sviluppo_cta: "Parliamo del tuo progetto",
    final_title: "Non sai da dove iniziare?",
    final_subtitle: "Raccontaci cosa ti serve, ti indirizziamo noi.",
    final_cta: "Contattaci",
  },
  about: {
    hero_kicker: "Chi siamo",
    hero_title: "Artigiani digitali del sorriso",
    image: LOGO,
    section_title: "Passione e ricerca al servizio del sorriso",
    para1: "Officina Dentale nasce dalla volontà di unire competenza tecnica, studio dei materiali e cura artigianale. Specializzati in protesi fissa e mobile, affrontiamo ogni caso con un metodo che parte dall'analisi clinica e arriva alla rifinitura finale con la stessa precisione, per offrire ai clinici manufatti affidabili ed esteticamente coerenti.",
    para2: "Ci occupiamo di restauri in zirconio e disilicato, tecnica \"DUO\" con barra fresata e ricopertura estetica, metallo-ceramica e protesi fissa ad alta precisione. A queste lavorazioni affianchiamo un workflow digitale controllato — progettazione CAD e un reparto di stampa 3D interno, calibrato e verificato periodicamente. Per noi il digitale non è il fine, ma lo strumento per garantire qualità, ripetibilità e stabilità del risultato.",
    values: [
      { title: "Precisione", desc: "Ogni caso è seguito dall'analisi iniziale alla rifinitura finale, con tolleranze rigorose e controlli costanti." },
      { title: "Ricerca continua", desc: "Studio costante di materiali, tecniche e protocolli per offrire soluzioni sempre aggiornate." },
      { title: "Cura artigianale", desc: "Competenza tecnica e mano artigianale per manufatti affidabili ed esteticamente coerenti." },
    ],
  },
  contatti: {
    hero_kicker: "Contatti",
    hero_title: "Parliamo del tuo progetto",
    hero_subtitle: "Richiedi informazioni sui nostri servizi di stampa 3D e progettazione. Ti risponderemo il prima possibile.",
    recapiti_title: "Recapiti",
    recapiti_phone_label: "Telefono",
    recapiti_email_label: "Email",
    recapiti_address_label: "Sede",
    form_name_label: "Nome e cognome",
    form_name_ph: "Mario Rossi",
    form_phone_label: "Telefono",
    form_phone_ph: "+39 ...",
    form_email_label: "Email",
    form_email_ph: "nome@studio.it",
    form_message_label: "Messaggio",
    form_message_ph: "Descrivi la tua richiesta...",
    form_submit: "Invia richiesta",
    success_title: "Grazie!",
    success_text: "Abbiamo ricevuto il tuo messaggio e ti ricontatteremo al più presto.",
    success_button: "Invia un altro messaggio",
  },
  announcement: {
    enabled: false,
    video: "",
    image: "",
    title: "",
    link: "",
    start_date: "",
    end_date: "",
  },
};

const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;

export function resolveImg(u) {
  if (!u) return u;
  if (typeof u === "string" && u.startsWith("/api")) return `${API_ORIGIN}${u}`;
  return u;
}

export function deepMerge(base, override) {
  if (Array.isArray(base)) return override !== undefined && override !== null ? override : base;
  if (base && typeof base === "object") {
    const out = { ...base };
    if (override && typeof override === "object") {
      for (const k of Object.keys(override)) {
        out[k] = k in base ? deepMerge(base[k], override[k]) : override[k];
      }
    }
    return out;
  }
  return override !== undefined ? override : base;
}
